module.exports = __webpack_public_path__ + "static/media/lips.603cb09c.svg";